import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit, OnDestroy {
  hidePassword = true;
  form = new FormGroup({
    username: new FormControl('', [
      Validators.required,
    ]),
    password: new FormControl('', [
      Validators.required,
    ])
  });
  private routeSub: any;
  redirectURL: string | undefined;

  constructor(
    public authService: AuthService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.routeSub = this.activatedRoute.queryParams.subscribe(async (params) => {
      this.redirectURL = params['redirectURL'];
    });
  }

  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
  }

}
